import { render, staticRenderFns } from "./PrintResep.vue?vue&type=template&id=79b4eb08&scoped=true&"
import script from "./PrintResep.vue?vue&type=script&lang=js&"
export * from "./PrintResep.vue?vue&type=script&lang=js&"
import style0 from "./PrintResep.vue?vue&type=style&index=0&id=79b4eb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b4eb08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
